import { Type } from '@angular/core';

import { DynamicComponent } from '../../types/dynamic-component.type';
import { AnyDynamicElement } from './dynamic-element.model';

export abstract class DynamicElementService {
    abstract getComponent(name: string): DynamicComponent;
    abstract addComponents(components: { [type: string]: Type<AnyDynamicElement> }[]): void;
}
